// Scope
const scope = 'loop/Events';

// Events
export const GET_EVENTS = `${scope}/GET_EVENTS`;
export const GET_EVENTS_SUCCESS = `${scope}/GET_EVENTS_SUCCESS`;
export const GET_EVENTS_ERROR = `${scope}/GET_EVENTS_ERROR`;

// Single Event
export const GET_SINGLE_EVENT = `${scope}/GET_SINGLE_EVENT`;
export const GET_SINGLE_EVENT_SUCCESS = `${scope}/GET_SINGLE_EVENT_SUCCESS`;
export const GET_SINGLE_EVENT_ERROR = `${scope}/GET_SINGLE_EVENT_ERROR`;

// Create/Edit Event
export const EDIT_EVENT = `${scope}/EDIT_EVENT`;
export const EDIT_EVENT_SUCCESS = `${scope}/EDIT_EVENT_SUCCESS`;
export const EDIT_EVENT_ERROR = `${scope}/EDIT_EVENT_ERROR`;


export const DELETE_EVENT = `${scope}/DELETE_EVENT`;
export const DELETE_EVENT_SUCCESS = `${scope}/DELETE_EVENT_SUCCESS`;
export const DELETE_EVENT_ERROR = `${scope}/DELETE_EVENT_ERROR`;

// Similiar Events
export const GET_SIMILIAR_EVENTS = `${scope}/GET_SIMILIAR_EVENTS`;
export const GET_SIMILIAR_EVENTS_SUCCESS = `${scope}/GET_SIMILIAR_EVENTS_SUCCESS`;
export const GET_SIMILIAR_EVENTS_ERROR = `${scope}/GET_SIMILIAR_EVENTS_ERROR`;

// Expired Events
export const GET_EXPIRED_EVENTS = `${scope}/GET_EXPIRED_EVENTS`;
export const GET_EXPIRED_EVENTS_SUCCESS = `${scope}/GET_EXPIRED_EVENTS_SUCCESS`;
export const GET_EXPIRED_EVENTS_ERROR = `${scope}/GET_EXPIRED_EVENTS_ERROR`;

// Companies
export const GET_COMPANIES = `${scope}/GET_COMPANIES`;
export const GET_COMPANIES_SUCCESS = `${scope}/GET_COMPANIES_SUCCESS`;
export const GET_COMPANIES_ERROR = `${scope}/GET_COMPANIES_ERROR`;

// Cities
export const GET_CITIES = `${scope}/GET_CITIES`;
export const GET_CITIES_SUCCESS = `${scope}/GET_CITIES_SUCCESS`;
export const GET_CITIES_ERROR = `${scope}/GET_CITIES_ERROR`;

// Per Page
export const EVENT_ITEMS_PER_PAGE = 12;
export const EXPIRED_EVENTS_PER_PAGE = 4;
export const SIMILAR_EVENTS_ITEMS_PER_PAGE = 4;

// Packages
export const GET_PACKAGES = `${scope}/GET_PACKAGES`;
export const GET_PACKAGES_SUCCESS = `${scope}/GET_PACKAGES_SUCCESS`;
export const GET_PACKAGES_ERROR = `${scope}/GET_PACKAGES_ERROR`;
